import { render, staticRenderFns } from "./ConfigDetails.vue?vue&type=template&id=7c0719fb&scoped=true"
import script from "./ConfigDetails.vue?vue&type=script&lang=js"
export * from "./ConfigDetails.vue?vue&type=script&lang=js"
import style0 from "./ConfigDetails.vue?vue&type=style&index=0&id=7c0719fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0719fb",
  null
  
)

export default component.exports